export default __webpack_public_path__ + "static/media/356.31acdcf9.png";